import { generateBaseQueryKeysList } from '@/queries/utils';

export const AIRPORTS_KEYS = {
  main: 'airports',
};

export const airportsQueryKeys = generateBaseQueryKeysList(AIRPORTS_KEYS.main);
